/**
 * Onboarding debug flag
 *
 * When `true`, completing or skipping the onboarding flow will NOT persist the
 * "done" state — neither to localStorage nor via the `finishOnboarding` GraphQL
 * mutation. This means the modal will reappear on every page reload, making it
 * easy to iterate on the onboarding UI without resetting the DB.
 *
 * Set to `false` for production and general use.
 */
export const ONBOARDING_DEBUG = false;

/**
 * Mobile highlight strategy for onboarding pointer cards.
 *
 * - `ring`    — pulsing pink outline ring (great for small elements)
 * - `bounce`  — scale bounce + ring (snappy, draws the eye)
 * - `glow`    — aggressive pink background glow (hardest to miss)
 * - `default` — original yellow validation flash (subtle)
 */
export const ONBOARDING_HIGHLIGHT: 'ring' | 'bounce' | 'glow' | 'default' = 'bounce';
